// extracted by mini-css-extract-plugin
module.exports = {"listCourse":"Course_listCourse_Cmu8C","coursesItem":"Course_coursesItem_3sNA_","courseBox":"Course_courseBox_3y3Ya","navigation":"Course_navigation_3dFFq"};